import { AutoComplete } from 'antd';
import { FC, useState } from 'react';

import { Reup_Product } from '@/graphql/types';
import { HandleAutoCompleteDraftOrderCallback } from '@/types/draftOrderTypes';

type AutoCompleteDraftOrderProductProps = {
  products: Reup_Product[];
  autoCompleteValue: string;
  onAutoCompleteSelect: HandleAutoCompleteDraftOrderCallback;
  purchaseOrderId: string;
};

const AutoCompleteDraftOrderProduct: FC<AutoCompleteDraftOrderProductProps> = ({
  products,
  autoCompleteValue,
  onAutoCompleteSelect,
  purchaseOrderId,
}) => {
  const [inputVal, setInputVal] = useState<string>('');

  const changeInput = (val: string) => {
    setInputVal(val);
  };

  const handleItemSelection = (val: string) => {
    onAutoCompleteSelect(val, purchaseOrderId);
    setInputVal('');
  };

  return (
    <AutoComplete
      style={{ width: 400 }}
      // eslint-disable-next-line react/destructuring-assignment
      options={products
        .sort((a, b) =>
          a.ProductName.toLocaleUpperCase().localeCompare(
            b.ProductName.toLocaleUpperCase()
          )
        )
        .map((p) => ({
          value: p.key,
          label: p.ProductName,
        }))}
      placeholder="Type to search"
      filterOption={(inputValue, option) => {
        return (
          option?.label.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
        );
      }}
      onSelect={handleItemSelection}
      onChange={changeInput}
      value={inputVal}
    />
  );
};

export default AutoCompleteDraftOrderProduct;
